import { render } from "./VerticalNavbar.vue?vue&type=template&id=6f9dbd86&scoped=true"
import script from "./VerticalNavbar.vue?vue&type=script&lang=js"
export * from "./VerticalNavbar.vue?vue&type=script&lang=js"

import "./VerticalNavbar.vue?vue&type=style&index=0&id=6f9dbd86&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9dbd86"]])

export default __exports__